export function pathToFileName(path: string): string {
  const pathComponents = path.split("/");
  return pathComponents[pathComponents.length - 1].split(".")[0];
}
